import { Permission } from '@weave/schema-gen-ts/dist/shared/waccess/acls.pb';
import { hasSchemaACL } from '@frontend/auth-helpers';
import { useAppScopeStore } from '@frontend/scope';

export const useHasAdminAccess = () => {
  // Maintaining a dedicated hook to check admin access as we would need to
  // add support for all accessible (multi-brand-analytics) locations in upcoming weeks
  const { selectedLocationIds: selectedLocationIdsInGLS = [] } = useAppScopeStore();
  return hasSchemaACL(selectedLocationIdsInGLS[0], Permission.ANALYTICS_ADMIN);
};
